import { defaultMaxHeight } from '../config/constants.js';
export const getWidgetMaxHeight = (theme) => {
    if (theme?.container?.maxHeight) {
        return theme?.container?.maxHeight;
    }
    if (theme?.container?.height && theme?.container?.height !== 'fit-content') {
        return theme?.container?.height;
    }
    return defaultMaxHeight;
};
//# sourceMappingURL=widgetSize.js.map